import { Box } from '@chakra-ui/react';
import { Grid, Group, Text } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';
import { repeat } from 'lodash';
import { Children, FC } from 'react';

export type SectionProps = {
  title?: string;
  direction?: 'vertical' | 'horizontal';
  paddingX?: string;
};

export const Section = forwardRef<SectionProps>(({ title, direction = 'vertical', children, ...props }, ref) => (
  <Box as="section" data-component="Section" {...props} ref={ref}>
    <Group variant="vertical" spacing="s" width="full">
      {title && (
        <Text textStyle="body5SemiUpper" color="neutral.darker" as="h2">
          {title}
        </Text>
      )}
      <Wrapper direction={direction}>{children}</Wrapper>
    </Group>
  </Box>
));
Section.displayName = 'Section';

const Wrapper: FC<Pick<SectionProps, 'direction'>> = ({ direction, children }) => {
  if (direction == 'horizontal') {
    return <Grid templateColumns={repeat('1fr ', Children.count(children))}>{children}</Grid>;
  }
  return (
    <Group hasDivider variant="vertical" spacing="s">
      {children}
    </Group>
  );
};
